import React, {
  useState,
  useContext,
  useRef,
  useEffect,
  useImperativeHandle,
} from "react";
import Space from "antd/es/space";
import Input from "antd/es/input";
import Button from "antd/es/button";
import Dropdown from "antd/es/dropdown";
import { DeleteOutlined } from "@ant-design/icons";
import { TipsContext } from "@/context/Tips";
import {
  getModuleList,
  createModule,
  deleteModule,
} from "@/server/moduleManager";
import CX from "classnames";
import "./index.less";

const typeList = ["测试1", "测试2"];

const AlertContent = React.forwardRef(({ menu }, ref) => {
  const [btnMsg, setBtnMsg] = useState("选择模块类型");
  const [inputVal, setInputVal] = useState("");

  useImperativeHandle(ref, () => ({
    moduleName: inputVal,
    type: btnMsg,
  }));

  return (
    <Space direction="vertical" size={10}>
      <Dropdown
        menu={{
          items: menu.map((m, i) => {
            return {
              key: m,
              label: m,
            };
          }),
          onClick: (e) => {
            setBtnMsg(e.key);
          },
        }}
      >
        <Button className="choose-module">{btnMsg}</Button>
      </Dropdown>
      <Input
        placeholder="输入模块名"
        onInput={(e) => {
          setInputVal(e.target.value);
        }}
      />
    </Space>
  );
});

export default function ModuleManager() {
  const [currentType, setCurrentType] = useState(0);
  const { useModal, useMessage } = useContext(TipsContext);
  const { modal } = useModal();
  const alertContentRef = useRef(null);
  const [moduleList, setModuleList] = useState([]);

  const matchTypeModuleList = (type) => {
    getModuleList({
      class: type,
    }).then((res) => {
      setModuleList(res);
    });
  };

  useEffect(() => {
    matchTypeModuleList(typeList[0]);
  }, []);

  useEffect(() => {
    // let i = 0
    // let timer = setInterval(() => {
    //     if (createdModule.includes(modules[i].name)) {
    //         return
    //     }
    //     createModule({ name: modules[i].name, type: typeList[0]})
    //     createdModule.push(modules[i].name)
    //     i += 1
    //     if (i === modules.length) {
    //         clearInterval(timer)
    //     }
    // }, 300)
  }, []);

  return (
    <div className="module-manager">
      <div
        className="add-module"
        onClick={() => {
          modal(
            {
              title: "添加模块",
              content: <AlertContent menu={typeList} ref={alertContentRef} />,
            },
            () => {
              const { moduleName, type } = alertContentRef.current;
              if (moduleName && typeList.includes(type)) {
                createModule({ name: moduleName, type }).then(
                  () => {
                    matchTypeModuleList(typeList[currentType]);
                    useMessage.success("添加成功");
                  },
                  () => {
                    useMessage.error("添加失败");
                  }
                );
              }
            }
          );
        }}
      >
        添加模块
      </div>
      <div className="module-list flex-row">
        <div
          style={{
            borderRight: "1px solid #DEDEDE",
          }}
        >
          <div className="title">模块类别</div>
          <div className="content flex-col">
            {typeList.map((m, index) => {
              return (
                <div
                  key={index}
                  onClick={() => {
                    setCurrentType(index);
                    matchTypeModuleList(m);
                  }}
                  className={CX({
                    "scroll-item": true,
                    active: currentType === index,
                  })}
                >
                  {m}
                </div>
              );
            })}
          </div>
        </div>
        <div className="module-name">
          <div className="title module">模块名称</div>
          <div className="content module">
            {moduleList.length > 0 &&
              moduleList.map((m, index) => {
                return (
                  <div key={"m" + index} className="scroll-item justify-around">
                    <div className="name">{m.name}</div>
                    <DeleteOutlined
                      onClick={() => {
                        const result = window.confirm("是否删除");
                        if (result === true) {
                          deleteModule(m.module_id).then(() => {
                            matchTypeModuleList(typeList[currentType]);
                          });
                        }
                      }}
                    />
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}
